import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const REFERRAL_CODE_STORAGE_KEY = 'tv_referral_code';

/**
 * /r/:code — the actual link partners/orgs share (see PartnerDashboard.jsx,
 * ChannelPartnersList.jsx, ReferAndEarn.jsx). Deliberately NOT /register?ref=...:
 * a query string named "ref" visibly tells anyone glancing at the URL or the
 * address bar that they're being tracked. This route exists only to catch
 * that one load, stash the code somewhere invisible, and hand off to a
 * completely clean /register — Register.jsx reads it from there instead of
 * the URL (see its REFERRAL_CODE_STORAGE_KEY usage).
 */
const ReferralRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      sessionStorage.setItem(REFERRAL_CODE_STORAGE_KEY, code.toUpperCase());
    }
    navigate('/register', { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ReferralRedirect;
